export function normalizeMetricFlags(survey, LANGS) {
    if (!survey || typeof survey !== 'object') return survey;
    const next = { ...survey };
    const langs = Array.isArray(LANGS) ? LANGS : Object.keys(survey || {});
    langs.forEach((lng) => {
        const section = next?.[lng];
        const qs = Array.isArray(section?.questionnaire) ? section.questionnaire : null;
        if (!qs) return;
        next[lng] = {
            ...(section || {}),
            questionnaire: qs.map((q) => {
                const idNum = Number(q?.questionID);
                const derivedMetric = idNum > 1000;
                return { ...q, isMetric: !!(q?.isMetric || derivedMetric) };
            }),
        };
    });
    return next;
}
